
    <fieldmagic-primary-button
      klass="p-0"
      purpose="icon"
      [icon]="[{
        icon: 'fingerprint',
        size: 'list-icon'
      }]"
      tooltip="Change Password"
      (click)="onChangePassword()"
    ></fieldmagic-primary-button>
  